import React from 'react';
import { useFormContext } from 'react-hook-form';
import SeatingCanvas from './components/SeatingCanvas';
import SeatingToolbar from './components/SeatingToolbar';
import SeatingStats from './components/SeatingStats';
import SeatingSelectionPanel from './components/SeatingSelectionPanel';
import { useSeatingCanvas } from './hooks/useSeatingCanvas';

const SeatingPlanEditor = ({
  record,
  isAssignMode,
  fullLayout,
  isViewOnly,
  isLayoutEdit,
  dataProvider,
  tickets,
  ticketsID,
  isCreateMode,
  layoutType,
  fullLayoutID,
}) => {
  const { setValue } = useFormContext();
  const useKonvaContainer = Boolean(isAssignMode || isViewOnly || isLayoutEdit);
  const showToolbar = Boolean(isLayoutEdit || (!isAssignMode && !isViewOnly));
  const showTicketStats = Boolean(isAssignMode && !isLayoutEdit && !isViewOnly);

  const {
    selectedShapes,
    setSelectedShapes,
    selectedTicket,
    setSelectedTicket,
    selectedAreaProducts,
    setSelectedAreaProducts,
    layoutLoaded,
    canvasSize,
    stageRef,
    layerRef,
    shadowRectRef,
    useTickets,
    setUseTickets,
    setField,
    handleAddShape,
    handleAddArea,
    handleAddBackgroundImage,
    handleRemoveBackgroundImage,
    handleDeleteShapes,
    handleCloneShape,
    handleChangeWidthHeight,
    handleRenameLabel,
    handleChangeBgColor,
    handleChangeFgColor,
    handleAssignTicket,
    handleAssignProductsToArea,
    handleLoadLayout,
    handleLoadLayoutJSONByID,
    handleLoadTicketsByID,
    handleLoadLayoutLocal,
    handleAddGridLayer,
    handleAddShadowRect,
    handleAddSelectionTool,
    handleAddBackgroundImageForDisplay,
  } = useSeatingCanvas({
    record,
    isAssignMode,
    fullLayout,
    isViewOnly,
    isLayoutEdit,
    dataProvider,
    tickets,
    ticketsID,
    isCreateMode,
    layoutType,
    fullLayoutID,
    setValue,
  });

  return (
    <div style={{ display: 'flex' }}>
      {!isViewOnly && (
        <div style={{ marginLeft: '20px', minWidth: '200px', marginRight: 20 }}>
          {showTicketStats && (
            <SeatingStats layerRef={layerRef} layoutType={layoutType} useTickets={useTickets} />
          )}

          <SeatingSelectionPanel
            selectedShapes={selectedShapes}
            setSelectedShapes={setSelectedShapes}
            selectedTicket={selectedTicket}
            setSelectedTicket={setSelectedTicket}
            selectedAreaProducts={selectedAreaProducts}
            setSelectedAreaProducts={setSelectedAreaProducts}
            isAssignMode={isAssignMode && !isLayoutEdit}
            layoutType={layoutType}
            useTickets={useTickets}
            layerRef={layerRef}
            stageRef={stageRef}
            setField={setField}
            onDeleteShapes={handleDeleteShapes}
            onCloneShape={handleCloneShape}
            onChangeWidthHeight={handleChangeWidthHeight}
            onRenameLabel={handleRenameLabel}
            onChangeBgColor={handleChangeBgColor}
            onChangeFgColor={handleChangeFgColor}
            onAssignTicket={handleAssignTicket}
            onAssignProductsToArea={handleAssignProductsToArea}
          />
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', border: '1px solid black' }}>
        {showToolbar && (
          <SeatingToolbar
            layoutType={layoutType}
            layerRef={layerRef}
            onAddShape={handleAddShape}
            onAddArea={handleAddArea}
            onAddBackgroundImage={handleAddBackgroundImage}
            onRemoveBackgroundImage={handleRemoveBackgroundImage}
          />
        )}

        <SeatingCanvas
          isAssignMode={useKonvaContainer}
          isViewOnly={isViewOnly}
          stageRef={stageRef}
          layerRef={layerRef}
          width={canvasSize.width}
          height={canvasSize.height}
        />

        {layoutType !== 'area' && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              height: 50,
              backgroundColor: 'lightgrey',
            }}
          >
            <div>STAGE</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SeatingPlanEditor;
